// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"dca92349","215":"595792b0","334":"7111a7ca","717":"595792b0","772":"9ee59e01"}[chunkId] + ".chunk.css";
};